import { useContext } from 'react';
import { BurgerMenuContext, IBurgerMenuContext } from 'context';

export function useBurgerMenu(): IBurgerMenuContext {
  return useContext(BurgerMenuContext)!;
}
